export { Router, ActivatedRoute } from '@angular/router';
export { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
export { MainService } from './providers/mainService.service';
export { HttpClient, HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
export { Observable } from 'rxjs/Observable';
export { Component, OnInit ,Injectable, Pipe, PipeTransform, ViewChild, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
export { NgxSpinnerService } from 'ngx-spinner';
export { ToastrService } from 'ngx-toastr';
export { INgxMyDpOptions } from 'ngx-mydatepicker';
export { Angular5Csv } from 'angular5-csv/Angular5-csv';
export { DomSanitizer } from '@angular/platform-browser';
// export { GlobalConstant } from './global/global.constant';



// WEBPACK FOOTER //
// /Users/tanveer/Documents/sportsYala_New/sportswebmobplatform-18023153-angular4/src/app/index.ts